const Palette = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' {...props}>
    <path
      d='M12 7.5C13.2426 7.5 14.25 6.49264 14.25 5.25C14.25 4.00736 13.2426 3 12 3C10.7574 3 9.75 4.00736 9.75 5.25C9.75 6.49264 10.7574 7.5 12 7.5Z'
      fill='currentColor'
    />
    <path
      d='M18 12C19.2426 12 20.25 10.9926 20.25 9.75C20.25 8.50736 19.2426 7.5 18 7.5C16.7574 7.5 15.75 8.50736 15.75 9.75C15.75 10.9926 16.7574 12 18 12Z'
      fill='currentColor'
    />
    <path
      d='M8.25 10.5C8.25 11.7426 7.24264 12.75 6 12.75C4.75736 12.75 3.75 11.7426 3.75 10.5C3.75 9.25736 4.75736 8.25 6 8.25C7.24264 8.25 8.25 9.25736 8.25 10.5Z'
      fill='currentColor'
    />
    <path
      d='M9 19.5C10.2426 19.5 11.25 18.4926 11.25 17.25C11.25 16.0074 10.2426 15 9 15C7.75736 15 6.75 16.0074 6.75 17.25C6.75 18.4926 7.75736 19.5 9 19.5Z'
      fill='currentColor'
    />
    <path
      d='M24 12C24 16.7259 21.2004 15.8775 18.6499 15.1046C17.1294 14.6438 15.6974 14.2099 15 15C14.0959 16.0244 14.2876 17.728 14.4735 19.379C14.7396 21.7434 14.9936 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22.5C12.9166 22.5 12.9804 22.2429 12.9822 22.2357C13.0993 22.0171 13.1683 21.5393 13.0871 20.5579C13.0662 20.3055 13.0323 20.0011 12.9956 19.6705C12.9182 18.9748 12.8279 18.1633 12.8187 17.4774C12.8045 16.4182 12.9439 15.0628 13.8754 14.0074C14.4278 13.3816 15.1425 13.1398 15.7825 13.0797C16.3892 13.0227 17.0016 13.1192 17.5223 13.236C18.037 13.3514 18.5758 13.5148 19.0601 13.6616L19.1032 13.6746C19.6212 13.8316 20.0887 13.9721 20.5319 14.0726C21.5115 14.2948 21.8878 14.1973 22.0189 14.1091C22.0761 14.0706 22.5 13.7417 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z'
      fill='currentColor'
    />
  </svg>
);

export default Palette;
